import * as yup from "yup";

const trackApplicationValidationSchema = yup.object({
  schemeType: yup
    .string()
    .required(Liferay.Language.get("scheme-type-is-required")),
  department: yup
    .string()
    .required(Liferay.Language.get("department-is-required")),
  schemeName: yup
    .string()
    .required(Liferay.Language.get("scheme-name-is-required")),
  applicationNo: yup
    .string()
    .trim()
    .required(Liferay.Language.get("application-id-is-required")),
  captchaValue: yup
    .string()
    .trim()
    .required(Liferay.Language.get("captcha-is-required"))
    .test(
      "captcha-match",
      Liferay.Language.get("captcha-does-not-match"),
      function (value) {
        if (!value) {
          return true;
        }

        return value === this.parent.generatedCaptcha;
      }
    ),
  generatedCaptcha: yup.string().required(),
});

export default trackApplicationValidationSchema;
